import type {
	Construction as ApiConstruction,
	Stage as ApiStage,
	StagesLock as ApiStagesLock,
	StageTotals as ApiStageTotals,
} from "@/adapters/api";
import type {
	ConstructionSummary,
	Stage,
	StagesLock,
	StageTotals,
} from "../types.ts";

export function toStage(s: ApiStage): Stage {
	return {
		id: s.id,
		parentId: s.parent_stage_id,
		name: s.name,
		description: s.description,
		status: s.status,
		kind: s.kind,
		position: s.position,
		depth: s.depth ?? 0,
		itemNumber: s.item_number ?? "",
		valueCents: s.value_cents,
	};
}

export function toStagesLock(l: ApiStagesLock | undefined): StagesLock {
	return {
		locked: !!l?.locked,
		changedAt: l?.changed_at,
		changedByName: l?.changed_by?.name,
	};
}

export function toStageTotals(
	t: ApiStageTotals | undefined,
): StageTotals | undefined {
	if (!t) return undefined;
	return {
		valued: t.valued,
		totalCents: t.total_cents,
		unvaluedLeaves: t.unvalued_leaves,
	};
}

export function toConstructionSummary(c: ApiConstruction): ConstructionSummary {
	return {
		id: c.id,
		name: c.name,
	};
}
